import React from 'react';
import './Help&Feedbacks.css'; // stylesheet
import { useNavigate } from 'react-router-dom';
import { FaLock, FaFileContract } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { IoIosArrowBack } from 'react-icons/io';
import FloatingSidebarButton from "../../components/FloatingSidebarButton/FloatingSidebarButton";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from "../../contexts/LanguageContext";

const Help = () => {
  const navigate = useNavigate();
  const { translations: t } = useLanguage();
  const { userProfile } = useAuth();

  return (
    <div className="help-container">
      <FloatingSidebarButton userProfile={userProfile} />

      <div className="help-card">
        <div className="help-header">
          <button
            className="help-back-button"
            onClick={() => navigate(-1)}
            aria-label={t.back || "Back"}
            title={t.back || "Back"}
          >
            <IoIosArrowBack size={24} />
          </button>
          <h2 className="help-title">
            {t.help?.title || "Help & Feedback"}
          </h2>
        </div>

        <div className="help-options-container">
          <div className="help-option" onClick={() => navigate('/contact')}>
            <div className="help-icon-container">
              <MdEmail className="help-icon" />
            </div>
            <span className="help-option-text">
              {t.help?.contactSupport || "Contact Support"}
            </span>
            <span className="help-option-arrow">→</span>
          </div>

          <div className="help-divider" />

          <div className="help-option" onClick={() => navigate('/privacy-policy')}>
            <div className="help-icon-container">
              <FaLock className="help-icon" />
            </div>
            <span className="help-option-text">
              {t.help?.privacyPolicy || "Privacy Policy"}
            </span>
            <span className="help-option-arrow">→</span>
          </div>

          <div className="help-option" onClick={() => navigate('/terms-of-services')}>
            <div className="help-icon-container">
              <FaFileContract className="help-icon" />
            </div>
            <span className="help-option-text">
              {t.help?.termsConditions || "Terms & Conditions"}
            </span>
            <span className="help-option-arrow">→</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
